// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_30f3XmftUHHSaC74nsCt01","checked":"_2exV1kRO4FDF7V5oj0Dd_F","disabled":"_3-mZWqrKe767zWi5nOfir7","selected":"EwCdtatolP5rIon2D_2U2"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/americanFootball/css/oddsButton.css
// module id = 766
// module chunks = 0